/* ==========================
   DOPESICK PRODUCT IMAGE CLICK OPEN
   ========================== */

document.addEventListener('DOMContentLoaded', () => {
  const productImages = document.querySelectorAll(
    '.product__media img, .product-gallery__image img, .product-gallery__thumbnail img'
  );

  productImages.forEach(img => {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', () => {
      // Open high-resolution image in new tab
      const imageUrl = img.src.replace(/_medium|_small|_compact/, '');
      window.open(imageUrl, '_blank');
    });
  });
});